/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {Component} from '@angular/core';

@Component({
    selector: 'app-portfolio-reports',
    templateUrl: './portfolio-reports.component.html',
    styleUrl: './portfolio-reports.component.scss',
    standalone: false
})
export class PortfolioReportsComponent {

}
